<template>
  <div class="header-container">
    <!-- 顶部导航栏 -->
    <div class="header-card">
      <!-- 左侧：公司信息和平台名称 -->
      <div class="header-left">
        <div class="company-info">
          <div class="company-name">hubintell</div>
          <div class="platform-name">签前一分钟-智能化合同编写平台</div>
        </div>
      </div>
      
      <!-- 右侧：用户信息和下拉菜单 -->
      <div class="header-right">
        <div 
          class="user-info" 
          @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave"
        >
          <span class="username">{{ userName }}</span>
          <span class="arrow" :class="{ 'arrow-up': showDropdown }">▼</span>
          
          <!-- 下拉菜单 -->
          <transition name="dropdown">
            <div 
              v-show="showDropdown" 
              class="dropdown-menu"
              @mouseenter="handleMenuEnter"
              @mouseleave="handleMenuLeave"
            >
              <div class="menu-item" @click="contactService">
                <span class="menu-icon">💬</span>
                <span>联系客服</span>
              </div>
              <div class="menu-item" @click="openManual">
                <span class="menu-icon">📖</span>
                <span>操作手册</span>
              </div>
              <div class="menu-item" @click="giveFeedback">
                <span class="menu-icon">💡</span>
                <span>意见反馈</span>
              </div>
              <div class="menu-divider"></div>
              <div class="menu-item logout" @click="logout">
                <span class="menu-icon">🚪</span>
                <span>退出登录</span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderCard',
  data() {
    return {
      userName: '用户名称',
      showDropdown: false,
      dropdownTimeout: null
    }
  },
  methods: {
    handleMouseEnter() {
      // 清除之前的隐藏定时器
      if (this.dropdownTimeout) {
        clearTimeout(this.dropdownTimeout);
        this.dropdownTimeout = null;
      }
      this.showDropdown = true;
    },
    
    handleMouseLeave() {
      // 设置延迟隐藏，给鼠标移动到菜单的时间
      this.dropdownTimeout = setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },
    
    handleMenuEnter() {
      // 鼠标进入菜单，清除隐藏定时器
      if (this.dropdownTimeout) {
        clearTimeout(this.dropdownTimeout);
        this.dropdownTimeout = null;
      }
      this.showDropdown = true;
    },
    
    handleMenuLeave() {
      // 鼠标离开菜单，立即隐藏
      this.showDropdown = false;
    },
    
    contactService() {
      console.log('联系客服');
      this.showDropdown = false;
    },
    
    openManual() {
      console.log('打开操作手册');
      this.showDropdown = false;
    },
    
    giveFeedback() {
      console.log('意见反馈');
      this.showDropdown = false;
    },
    
    logout() {
      console.log('退出登录');
      this.showDropdown = false;
    }
  }
}
</script>

<style scoped>
.header-container {
  width: 100%;
  margin-bottom: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%; /* 恢复全宽 */
  background: #FFFFFF;
  border-radius: 0; /* 移除圆角，完全贴合顶部 */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 15px 30px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-top: none;
  border-left: none;
  border-right: none;
}

/* 左侧样式 */
.header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 40px; /* 增加左侧外边距，使整体内容向右移动 */
}

.company-info {
  display: flex;
  align-items: baseline;
  margin-bottom: 5px;
}

.company-name {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-right: 25px; /* 增加公司名称和平台名称之间的间距 */
  font-family: "黑体", "SimHei", sans-serif;
}

.platform-name {
  font-size: 18px;
  color: #666;
  font-weight: 500;
  margin-left: 10px; /* 额外增加平台名称的左外边距 */
}

.register-info {
  font-size: 12px;
  color: #999;
}

/* 右侧样式 */
.header-right {
  position: relative;
}

.user-info {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.user-info:hover {
  background-color: rgba(102, 126, 234, 0.05);
}

.username {
  font-size: 16px;
  color: #333;
  margin-right: 8px;
  font-weight: 500;
}

.arrow {
  font-size: 12px;
  color: #666;
  transition: transform 0.3s ease;
}

.arrow-up {
  transform: rotate(180deg);
}

/* 下拉菜单样式 */
.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  padding: 8px 0;
  min-width: 160px;
  z-index: 1000;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-top: 8px; /* 增加与触发区域的距离 */
}

/* 下拉菜单动画 */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 14px;
  color: #333;
}

.menu-item:hover {
  background-color: rgba(102, 126, 234, 0.05);
}

.menu-item.logout {
  color: #ff4757;
}

.menu-item.logout:hover {
  background-color: rgba(255, 71, 87, 0.05);
}

.menu-icon {
  margin-right: 10px;
  font-size: 16px;
}

.menu-divider {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 8px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-card {
    padding: 12px 20px;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .header-left {
    margin-left: 0; /* 在移动端重置左边距 */
  }
  
  .header-right {
    margin-top: 12px;
    align-self: flex-end;
  }
  
  .company-info {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .platform-name {
    margin-top: 5px;
    font-size: 16px;
    margin-left: 0; /* 在移动端重置左边距 */
  }
  
  .company-name {
    margin-right: 0; /* 在移动端重置右边距 */
  }
}

@media (max-width: 480px) {
  .header-card {
    padding: 10px 15px;
  }
  
  .company-name {
    font-size: 20px;
  }
  
  .platform-name {
    font-size: 14px;
  }
  
  .dropdown-menu {
    min-width: 140px;
  }
}
</style>